export default {
    mapsKey : 'AIzaSyBfCgBOZYAREEGpkePYP7zHHZ6jJuwg9Mc'
}